import Moment from 'moment';
import * as CONST from './constants';

const url = require('url');

var Utils = (function () {
  var formatKNumber = function (num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k'
      : Math.sign(num) * Math.abs(num);
  };

  var getCoverImgPath = function (extract_knowledgearea, job_cover_path) {
    if (job_cover_path && job_cover_path !== '') {
      const path = job_cover_path;
      return path;
    } else if (extract_knowledgearea && extract_knowledgearea !== '') {
      const path = CONST.DEFAULT_JOBCOVER_PATH + extract_knowledgearea + '.jpg';
      return path;
    } else {
      const path = 'img/dummy.png';
      return path;
    }
  };

  /**
   * Novo id numérico para etapa customizada do funil, sem colisão com etapas existentes.
   * @param {Array<string|number>} existingStageIds - IDs de etapas já existentes (internas e customizadas)
   * @returns {number} ID numérico único para nova etapa customizada
   */
  const allocateUniquePipelineStageId = (existingStageIds) => {
    const usedIds = new Set();
    const reservedIds = Array.isArray(CONST.INTERNAL_STAGES)
      ? CONST.INTERNAL_STAGES
      : [0, 900, 999, 1000];

    reservedIds.forEach(function (reservedId) {
      const numericReserved = Number(reservedId);

      if (!Number.isNaN(numericReserved)) {
        usedIds.add(numericReserved);
      }
    });

    const existingIds = Array.isArray(existingStageIds) ? existingStageIds : [];

    existingIds.forEach((rawStageId) => {
      const parsed =
        typeof rawStageId === 'string' && String(rawStageId).trim() !== ''
          ? parseInt(rawStageId, 10)
          : Number(rawStageId);

      if (!Number.isNaN(parsed)) usedIds.add(parsed);
    });

    let lowRangeId = 1;
    while (lowRangeId <= 899) {
      if (!usedIds.has(lowRangeId)) return lowRangeId;
      lowRangeId += 1;
    }

    for (let midRangeId = 901; midRangeId <= 998; midRangeId += 1) {
      if (!usedIds.has(midRangeId)) return midRangeId;
    }

    let highRangeId = 1001;
    while (usedIds.has(highRangeId)) highRangeId += 1;

    return highRangeId;
  };

  var isValidDate = function (d) {
    return d instanceof Date && !isNaN(d);
  };

  var matchPresentDate = function (text) {
    let match = false;

    if (text && text !== '') {
      // FIXME: Maybe move this to an external DIC
      const arrWordsEN = ['present', 'current', 'currently', 'now', 'day'];
      const arrWordsPT = ['presente', 'atual', 'momento', 'atualmente', 'hoje', 'dias atuais'];
      const arrWordsES = ['actualmente', 'momento', 'actual', 'presente'];

      const words = arrWordsEN.concat(arrWordsES).concat(arrWordsPT);

      match = words.includes(text.toLowerCase());
    }

    return match;
  };

  var getFirstLetters = function (str) {
    const firstLetters = str
      .split(' ')
      .map((word) => word[0])
      .join('');

    return firstLetters;
  };

  var dynamicSort = function (property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  };

  var hideInfo = function (info) {
    if (typeof info === 'string') {
      if (info.length <= 2) {
        // If the string has 2 or fewer characters, return it as it is
        return info;
      }

      // Keep the first and last characters, replace the middle part
      let firstChar = info[0];
      let lastChar = info[info.length - 1];
      let middlePart = '*'.repeat(info.length - 2); // Replace middle with asterisks

      return firstChar + middlePart + lastChar;
    } else {
      return info;
    }
  };

  var hideAllInfo = function (info) {
    if (typeof info === 'string') {
      return '*'.repeat(info.length);
    } else {
      return info;
    }
  };

  var hasDiversity = function (country) {
    let canAskBirthday = country === 'US' || country === 'CA' ? false : true;
    let canAskDiversity = country === 'BR' ? true : false;

    return {
      canAskBirthday: canAskBirthday,
      canAskDiversity: canAskDiversity
    };
  };

  var hasDiversityMatch = function (applicant) {
    let hasDiversity = false;

    const pwrMatch = ['B', 'C', 'D', 'E', 'F'];
    const psoMatch = ['B', 'C', 'D', 'F', 'H', 'I', 'J'];
    const pgiMatch = ['C', 'D', 'E', 'F', 'G', 'H'];
    const genderMatch = ['NB', 'O'];

    if (
      pwrMatch.includes(applicant.pwr) ||
      psoMatch.includes(applicant.pso) ||
      pgiMatch.includes(applicant.pgi) ||
      genderMatch.includes(applicant.gender)
    ) {
      hasDiversity = true;
    }

    return hasDiversity;
  };

  var hasPwdMatch = function (applicant) {
    let hasPwd = false;

    const pwdMatch = [
      'physically_impaired',
      'hearing_impaired',
      'visually_impaired',
      'mentally_impaired',
      'multiple_disabilities',
      'neurodivergent',
      'psychosocial_disability'
    ];

    if (pwdMatch.includes(applicant.pwd)) {
      hasPwd = true;
    }

    return hasPwd;
  };

  var isLinkedInProfile = function (profile_url) {
    let isLinkedInProfile = false;
    const decoded_url = decodeURI(profile_url);
    if (decoded_url.includes('linkedin') && decoded_url.includes('/in/')) {
      isLinkedInProfile = true;
    }
    return isLinkedInProfile;
  };

  var getLinkedInProfileFromUrl = function (profile_url) {
    if (isLinkedInProfile(profile_url)) {
      const decurl = url.parse(profile_url);
      const pathurl = decurl.path.split('/')[2];
      const prof = pathurl.split('?')[0];
      return prof;
    } else {
      return null;
    }
  };

  var applicantSalaryMatch = function (applicantSalaryInfo, jobSalaryInfo) {
    const SALARY_FIXED = 'fixed';
    const SALARY_RANGE = 'range';
    let match = false;

    const salaryType = applicantSalaryInfo.max ? SALARY_RANGE : SALARY_FIXED;

    if (jobSalaryInfo) {
      const jobSalaryType = jobSalaryInfo.max ? SALARY_RANGE : SALARY_FIXED;
      const jobSalaryMax = jobSalaryType === SALARY_FIXED ? jobSalaryInfo.min : jobSalaryInfo.max;

      const matchCurrencyAndDuration =
        applicantSalaryInfo.currency === jobSalaryInfo.currency &&
        applicantSalaryInfo.duration === jobSalaryInfo.duration;

      let matchSalary = false;
      if (salaryType === SALARY_FIXED) {
        matchSalary = parseInt(applicantSalaryInfo.min) <= parseInt(jobSalaryMax);
      } else {
        matchSalary = parseInt(applicantSalaryInfo.max) <= parseInt(jobSalaryMax);
      }

      match = matchCurrencyAndDuration && matchSalary;
    }

    return match;
  };

  var removeAccents = function (str) {
    let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    let accentsOut = 'AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    str = str.split('');
    str.forEach((letter, index) => {
      let i = accents.indexOf(letter);
      if (i !== -1) {
        str[index] = accentsOut[i];
      }
    });
    return str.join('');
  };

  var decodeHTMLEntities = function (text) {
    if (!text) return '';

    return text.replace(/&#x([0-9A-F]+);/gi, (match, hex) => {
      return String.fromCharCode(parseInt(hex, 16));
    });
  };

  var removeSpecialChars = function (str, replace) {
    let normalized = str.replace(/-/g, replace);
    normalized = normalized.replace(/\+/g, replace);
    normalized = normalized.replace(/_/g, ' ');
    normalized = normalized.replace(/[&/\\,()±–§$~°º%.'":;*?<>{}]/g, replace);

    return normalized;
  };

  var getCustomTestQuestionKey = function (questionText) {
    const decoded = decodeHTMLEntities(questionText || '');
    const withoutAccents = removeAccents(decoded);
    const withoutSpecial = removeSpecialChars(withoutAccents, '');

    return withoutSpecial.replace(/\s+/g, '_').toLowerCase();
  };

  var parseJsonObject = function (value) {
    if (value == null) return null;

    if (typeof value === 'object') {
      return Array.isArray(value) ? null : value;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return null;

      try {
        const parsed = JSON.parse(trimmed);
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
          return null;
        }

        return parsed;
      } catch {
        return null;
      }
    }

    return null;
  };

  var setMomentLocaleWithTimezone = function (language, dateToFormat, timezone, formatString) {
    if (language) {
      Moment.locale(language);
      return Moment(dateToFormat).utc().tz(timezone).format(formatString);
    }

    return Moment(dateToFormat).utc().tz(timezone).format(formatString);
  };

  var setMomentLocale = function (language, dateToFormat, formatString) {
    if (language) {
      Moment.locale(language);
      return Moment(dateToFormat).format(formatString);
    }

    return Moment(dateToFormat).format(formatString);
  };

  /** Formata data de nascimento (ou qualquer data "só dia") em texto por extenso.
   * @param {string|Date} date Data com timezone (ex.: ISO com offset)
   * @param {string} locale Locale do Moment (ex.: 'pt-BR', 'en')
   * @returns {string|null} Data formatada (ex.: "04 de maio de 1998") ou null se inválida.
   */
  var formatBirthDate = function (date, locale) {
    if (!date || !Moment(date).isValid()) return null;

    const m = Moment.utc(date);
    if (!m.isValid()) return null;

    return m.locale(locale || 'pt-BR').format('LL');
  };

  var isValidEmail = function (email) {
    // Regular expression for email validation
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email ? emailRegex.test(String(email).toLowerCase()) : true; // Returns true if empty or valid
  };

  const parsePhoneNumber = (phone, removeDDI) => {
    if (!phone) {
      return '';
    }

    const digitsOnly = `${phone}`.replace(/\D/g, '').replace(/^0+/, '');

    if (!digitsOnly) {
      return '';
    }

    let localNumber = digitsOnly;

    if (removeDDI && localNumber.startsWith('55') && localNumber.length > 11) {
      localNumber = localNumber.slice(2);
    }

    if (!localNumber) {
      return '';
    }

    return localNumber;
  };

  return {
    applicantSalaryMatch: applicantSalaryMatch,
    decodeHTMLEntities: decodeHTMLEntities,
    dynamicSort: dynamicSort,
    formatBirthDate: formatBirthDate,
    formatKNumber: formatKNumber,
    getCoverImgPath: getCoverImgPath,
    getCustomTestQuestionKey: getCustomTestQuestionKey,
    getFirstLetters: getFirstLetters,
    getLinkedInProfileFromUrl: getLinkedInProfileFromUrl,
    allocateUniquePipelineStageId: allocateUniquePipelineStageId,
    hasDiversity: hasDiversity,
    hasDiversityMatch: hasDiversityMatch,
    hasPwdMatch: hasPwdMatch,
    hideAllInfo: hideAllInfo,
    hideInfo: hideInfo,
    isLinkedInProfile: isLinkedInProfile,
    isValidDate: isValidDate,
    isValidEmail: isValidEmail,
    matchPresentDate: matchPresentDate,
    parseJsonObject: parseJsonObject,
    parsePhoneNumber: parsePhoneNumber,
    removeAccents: removeAccents,
    removeSpecialChars: removeSpecialChars,
    setMomentLocale: setMomentLocale,
    setMomentLocaleWithTimezone: setMomentLocaleWithTimezone
  };
})();

export default Utils;
